import { render, staticRenderFns } from "./LessonErrorScreen.vue?vue&type=template&id=25fc85d9&scoped=true&"
import script from "./LessonErrorScreen.vue?vue&type=script&lang=ts&"
export * from "./LessonErrorScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LessonErrorScreen.vue?vue&type=style&index=0&id=25fc85d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc85d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25fc85d9', component.options)
    } else {
      api.reload('25fc85d9', component.options)
    }
    module.hot.accept("./LessonErrorScreen.vue?vue&type=template&id=25fc85d9&scoped=true&", function () {
      api.rerender('25fc85d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/lessons/lesson/LessonErrorScreen.vue"
export default component.exports